import React from "react";

const LoadingVenues = () => {
  return (
    <div className="row" style={{ padding: "50px" }}>
      <div className="col-sm-12 text-center">
        <div style={{ fontSize: "25px" }}>🍔🥗🍕🛒🛍️</div>{I18n.t("pages.locations.venues.loading")}
      </div>
    </div>
  );
}

export default LoadingVenues;
